import * as React from 'react';

import ComposableTable, { Props as ComposableTableProps } from './ComposableTable';

type Props<T> = ComposableTableProps<T> & {
  pageHeader: React.ReactElement<any>;
  pageHeaderHeight: number;
};

export function ComposableTableWithFixedPageHeader<T>(props: Props<T>) {
  const { pageHeader, pageHeaderHeight, ...tableProps } = props;
  return (
    <div>
      {pageHeader}
      <ComposableTable<T> topOffset={pageHeaderHeight} {...tableProps} />
    </div>
  );
}
